import React from 'react'
import PropTypes from 'prop-types'
import connectPropTypes from './utilities/connectPropTypes'
import EmailRedirectUrlInputAndValidation from './components/EmailRedirectUrlInputAndValidation'
import deviceDetect from './utilities/deviceDetect'
import styles from './LoginEmail.icss'

const handleUrlSubmit = (url) => {
	global.location.href = url
}

class LoginEmail extends React.Component {
	constructor(props) {
		super(props)

		//	On iOS using instagram or pwa, we need to paste the url in when using email.
		this.needsUrlPasted = deviceDetect.isIos() && (deviceDetect.isInstagram() || deviceDetect.isPwa())
	}

	componentDidMount() {
		this.props.appShowBottomBar(false)
	}

	componentWillUnmount() {
		this.props.authReset()
	}

	render() {
		return (
			<div className={styles.loginEmailWrapper}>
				<section className={styles.infoWrapper}>
					<h2>{this.context.translate('Check Your Email')}</h2>
					{this.needsUrlPasted && (
						<React.Fragment>
							<p>
								{this.context.translate(`We've sent a log in link to your email (${this.props.emailSent}), once it arrives copy it and paste it in below.`)}
							</p>
							<EmailRedirectUrlInputAndValidation
								fullWidth
								urlHandler={handleUrlSubmit}
								label={this.context.translate('Login Url')}
								buttonText={this.context.translate('Submit')}
							/>
						</React.Fragment>
					)}
					{!this.needsUrlPasted && (
						<React.Fragment>
							<p>
								{this.context.translate(`We've sent a log in link to your email (${this.props.emailSent}). Click it and you’ll be signed in.`)}
							</p>
							<p>
								{this.context.translate('NB: We’ll try to keep you signed in but if you come back and need to log in again just repeat this process. Easy peasy!')}
							</p>
						</React.Fragment>
					)}
				</section>
			</div>
		)
	}
}

LoginEmail.contextTypes = {
	translate: PropTypes.func
}

LoginEmail.propTypes = {
	emailSent: PropTypes.string,
	appShowBottomBar: PropTypes.func.isRequired,
	authReset: PropTypes.func.isRequired
}

LoginEmail.defaultProps = {
	emailSent: undefined
}

export const testing = {
	LoginEmail
}

export default connectPropTypes(LoginEmail)



// WEBPACK FOOTER //
// ./src/LoginEmailSent.jsx